export const pravilnik_o_poslovnoj_tajni= {
    templateId: 220,
    category: 14,
    templateTitle: 'Pravilnik o poslovnoj tajni',
    templateDescription: `<p>Upoznavanje radnika s podacima koji se smatraju poslovnom tajnom preduvjet je dokazivanja povrede poslovne tajne. Pravilnikom se određuje koji se podaci kod poslodavca smatraju poslovnom tajnom, priopćavanje poslovne tajne, čuvanje poslovne tajne, pribavljanje, korištenje i otkrivanje poslovnih tajni,  posljedice nepridržavanja, kao i mjere, postupci i druge okolnosti od interesa poslodavca za čuvanje poslovne tajne.    </p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Poslovna tajna definirana je Zakonom o zaštiti tajnosti podataka, Zakonom o tajnosti podataka te Zakonom o zaštiti neobjavljenih informacija s tržišnom vrijednosti.</p>
    <p>Spomenutim zakonima određuje se čuvanje poslovne tajne, posljedice nepridržavanja, izuzeci, mjere i sl..    </p>
    <p>Nedavno doneseni Zakon o zaštiti neobjavljenih informacija s tržišnom vrijednosti proširuje pojam poslovnih tajni i na dio nematerijalnih prava kojima poslodavac raspolaže, kao što su iskustvo, know-how, razne tehnološke informacije, a koje se inače ne mogu zaštititi kao intelektualne tvorevine sukladno odredbama autorskog prava.</p>
    <p>Poslovna tajna u smislu navedenog zakona su informacije koje ispunjavanju sve sljedeće zahtjeve</p>
    <li>tajne su jer nisu, u svojoj ukupnosti ili u točnoj strukturi i sklopu svojih sastavnih dijelova, općenito poznate ili lako dostupne osobama iz krugova koji se obično bave predmetnom vrstom informacija,</li>
    <li>imaju tržišnu (komercijalnu) vrijednost zbog toga što su tajne, </li>
    <li>u odnosu na njih osoba koja te informacije zakonito kontrolira poduzela je u tim okolnostima razumne korake kako bi sačuvala njihovu tajnost.</li>

    <p>Razumni koraci mogu biti: </p>
    <li>izradu <strong>internog akta</strong> o rukovanju poslovnom tajnom i krugu osoba te njihovim pravima i obvezama kod rukovanja poslovnom tajnom, ili </li>
    <li>mjere fizičke ili virtualne zaštite pristupa i rukovanja poslovnom tajnom</li>

    <p>Spomenuti zakon i proširuje pojam poslovnih tajni i na dio nematerijalnih prava kojima poslodavac raspolaže, kao što su iskustvo, know-how, razne tehnološke informacije, a koje se inače ne mogu zaštititi kao intelektualne tvorevine sukladno odredbama autorskog prava.</p>

    <p>Tnterni akt svakako olakšava dokazivanje povrede poslovne tajne, a svakako i prvenira buduće povrede poslovnih tajni.</p>
    <p>Dodatno se predlaže unijeti odredbe o povredi poslovne tajne i u ugovor o radu, a takve odredbe su i unesene u predloške ugovora o radu koji sadržavaju dodatne odredbe.</p>
    <p>Važno je reći da je odavanje i neovlašteno korištenje poslovne tajne kazneno djelo u smislu odredi Kaznenog zakona te je za isto propisana kazna zatvora do tri godine. </p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o zaštiti tajnosti podataka, Zakon o tajnosti podataka, Zakon o zaštiti neobjavljenih informacija s tržišnom vrijednosti te Kazneni zakon.</p>
  `,

  sides: [
    {
        signature: 'Za Poslodavca',
        inputs: [{
            type: "input",
            required: true,
            placeholder: "Poslovni subjekt",
          },
          {
            type: "input",
            required: true,
            placeholder: "Ulica i kućni broj",
          },
          {
            type: "input",
            required: true,
            placeholder: "Mjesto",
          },
          {
            type: "input",
            required: true,
            placeholder: "OIB",
          },
          {
            type: "input",
            placeholder: "Zastupa",
            inSignature: true,
          },
          {
            type: "input",
            placeholder: "Funkcija",
            inSignature: true,
          }],
        suffix: ' (u daljnjem tekstu: Poslodavac),',
    }
],

headline: '​donosi sljedeći',
title: 'PRAVILNIK O POSLOVNOJ TAJNI',

articles: [
    
    {
        title: 'PREDMET PRAVILNIKA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                help: "Zakonom nije dopušteno odrediti da se svi podaci koji se odnose na poslovanje pravne osobe smatraju poslovnom tajnom niti se poslovnom tajnom mogu odrediti podaci čije priopćavanje nije razložno protivno interesima te pravne osobe.",
                content: 'Ovim Pravilnikom određuju se podaci koji se kod Poslodavca smatraju poslovnom tajnom, čuvanje poslovne tajne, priopćavanje poslovne tajne, izuzeci, pribavljanje, korištenje i otkrivanje poslovne tajne,  posljedice nepridržavanja, kao i mjere, postupci i druge okolnosti od interesa Poslodavca za čuvanje poslovne tajne.',
            },
        ],
    },
    {
        title: 'DEFINICIJE',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Poslovnu tajnu čine podaci, znanje i iskustvo, poslovne informacije, tehnološke informacije, proizvodne tajne, rezultati istraživačkog ili konstrukcijskog rada,  koji su kao poslovna tajna određeni zakonom, na zakonu utemeljenim propisom ili ovim Pravilnikom te drugi podaci zbog čijeg bi priopćavanja neovlaštenoj osobi mogle nastupiti štetne posljedice za gospodarske interese Poslodavca.\r\nPodatak  je dokument, odnosno svaki napisani, umnoženi, nacrtani, slikovni, tiskani, snimljeni, fotografirani, magnetni, optički, elektronički ili bilo koji drugi zapis podatka, saznanje, mjera, postupak, predmet, usmeno priopćenje ili informacija, koja s obzirom na svoj sadržaj ima važnost povjerljivosti i cjelovitosti za svoga vlasnika. \r\nOsim toga, poslovnom tajnom se u smislu ovog Pravilnika smatraju se i podaci, znanje i iskustvo, poslovne informacije i tehnološke informacije,  koji se odnose na neobjavljene informacije koje imaju tržišnu (komercijalnu) vrijednost, a koje:\r\na) nisu općenito poznate ili lako dostupne osobama iz krugova koji se obično bave predmetnom vrstom informacija u svojoj ukupnosti ili u točnoj strukturi i sklopu svojih sastavnih dijelova, \r\nb) imaju tržišnu (komercijalnu) vrijednost zbog toga što su tajne, jer bi njihovo nezakonito pribavljanje, korištenje ili otkrivanje moglo naštetiti interesima Poslodavca iz razloga što se time narušavaju njegovi znanstveni i tehnički potencijal, poslovni ili financijski interesi, strateške pozicije ili sposobnost tržišnog natjecanja.\r\nPoslodavac je donošenjem ovog Pravilnika poduzeo razumne korake koji se odnose na rukovanje podacima, znanjem i iskustvom, poslovnim i tehnološkim informacijama, kao i odredio krug osoba te njihova prava i obveze kod rukovanja.',
            },
        ],
        value: '',
    },
    {
        title: 'POSLOVNA TAJNA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Osim definiranja poslovne tajne u prethodnim odredbama ovog Pravilnika, u nastavku se i pobliže specificiraju određene poslovne tajne te u tom smislu Poslodavac određuje da se poslovnom tajnom osobito smatraju podaci, znanje i iskustvo, poslovne informacije i tehnološke informacije koji su nastali iz, ili su posredno ili neposredno povezani s: \r\n- radom Skupštine i drugih upravljačkih tijela, njihovim sastancima i zasjedanjima, \r\n- internim i eksternim ugovorima Poslodavca, posebno onima koji financijski obvezuju Poslodavca, \r\n- pregovorima i sadržajem tih pregovora u poslovnim odnosima s poslovnim partnerima u obavljanju osnovnih i sporednih djelatnosti, \r\n- financijskim poslovanjem Poslodavca, kreditima, financijskom strategijom i pokazateljima, osim kada postoji zakonska obveza objavljivanja istih, \r\n- poslovnim odnosom i dogovorima Poslodavca s njegovih poslovnim partnerima u pogledu količina, vrsta, cijena roba i usluga, popusta, rabata, odobrenja, eventualnih odobrenih bonifikacija, \r\n- procesima koji se obavljaju kod Poslodavca, ispitivanjima, istraživanjima i njihovim rezultatima, kao i patentima, žigovima te svim autorskim pravima, kao i originalnim intelektualnim tvorevinama, bez obzira uživaju li autorsku zaštitu ili ne, \r\n- visinom plaća, stimulacija i drugim materijalnim pravima (dnevnice, putni troškovi itd.) radnika, \r\n- drugim podacima čije bi priopćavanje neovlaštenim osobama moglo prouzročiti štetne posljedice za poslovne interese Poslodavca, bilo u financijskom, bilo u nekom drugom smislu i sl..\r\nPoslovnom tajnom također smatraju se i podaci pohranjeni u elektroničkim bazama podataka na računalima, e-mail prepiske i sl.,  a vezani su uz poslovne tajne iz ovog Pravilnika.',
                value: '',
            },
        ],
        value: '',
    },
    {
        title: 'OSTALI PODACI KOJI SE SMATRAJU POSLOVNOM TAJNOM',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Radnici Poslodavca su kao poslovnu tajnu dužni čuvati i podatke: \r\n- koje su kao poslovnu tajnu saznali u radu od drugih fizičkih ili pravnih osoba, \r\n- koji se odnose na poslove što ih Poslodavac obavlja za potrebe oružanih snaga, redarstvenih vlasti Republike Hrvatske ili drugih javnih tijela, ako su zaštićeni određenim stupnjem tajnosti,\r\n- podatke koji sadrže ponude na natječaj ili dražbu - do objavljivanja rezultata natječaja odnosno dražbe, \r\n- podatke koji su zakonom, drugim propisom ili općim aktom doneseni na temelju zakona utvrđeni tajnim podacima od posebnog gospodarskog značenja. \r\nZa pojedine slučajeve u kojima je iz razloga obavljanja poslova pravne ili fizičke osobe nužno priopćavanje takvih podataka, zatražiti će se suglasnost za objavu takvih podataka, sukladno važećim propisima.',
                value: '',
            },
        ],
        value: '',
    },
    {
        title: 'ČUVANJE POSLOVNE TAJNE',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Podaci koji se smatraju poslovnom tajnom ne smiju se priopćavati niti činiti dostupnim neovlaštenim osobama, osim na način određen ovim Pravilnikom.\r\nPoslovnu tajnu dužni su čuvati svi radnici koji na bilo koji način saznaju za podatak koji se smatra poslovnom tajnom. ',
                value: '',
            },
        ],
        value: '',
    },
    {
        title: 'PRIOPĆAVANJE POSLOVNE TAJNE',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Podatke koji se smatraju poslovnom tajnom mogu priopćavati i učiniti dostupnima drugim osobama samo osobe ovlaštene za zastupanje Poslodavca ili osobe kojim osoba ovlaštena za zastupanje poslodavca da takvu ovlast.  \r\nOsoba ovlaštena za zastupanje Poslodavca takvu ovlast može dati jednoj ili više osoba. \r\nObveza čuvanja poslovne tajne traje i nakon prestanka statusa osobe slijedom kojeg je toj osobi tajna priopćena, sve dok se odnosni podatak smatra poslovnom tajnom. \r\nOsoba ovlaštena za zastupanje Poslodavca odlučuje kada određeni podatak prestaje biti poslovna tajna, ako isto nije propisano zakonom.',
                value: '',
            },
        ],
        value: '',
    },
    {
        title: 'IZUZECI',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Ne smatra se povredom čuvanja poslovne tajne priopćavanje podataka koji se smatraju poslovnom tajnom, ako se to priopćavanje obavlja fizičkim osobama ili pravnim osobama kojima se takvi podaci mogu ili moraju priopćavati:\r\n- na temelju zakona i drugih propisa, \r\n- na temelju ovlasti koja proizlazi iz dužnosti koju obavljaju, položaja na kome se nalaze ili radnog mjesta na kojem su zaposleni, ako je to nužno za uspješno obavljanje poslova Poslodavca, \r\n- na sjednicama i kolegijima Poslodavca, ako je to nužno za uspješno obavljanje poslova Poslodavca. \r\nOvlaštena osoba koja na sjednici priopćava podatke koji se smatraju poslovnom tajnom, dužna je upozoriti nazočne da se ti podaci smatraju poslovnom tajnom, a nazočni su dužni ono što tom prilikom saznaju čuvati kao poslovnu tajnu. \r\nKao povreda čuvanja poslovne tajne neće se smatrati priopćenje koje osoba upoznata s poslovnom tajnom učini u prijavi kaznenog djela ili prekršaja nadležnom tijelu te ako priopći nadzornom tijelu radi ostvarivanja svojih prava iz radnog odnosa. ',
                value: '',
            },
        ],
        value: '',
    },
    {
        title: 'ZAKONITO PRIBAVLJANJE, KORIŠTENJE I OTKRIVANJE POSLOVNIH TAJNI',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Pribavljanje poslovne tajne smatra se zakonitim kada je poslovna tajna pribavljena na jedan od sljedećih načina: \r\na) neovisnim otkrićem ili stvaranjem, \r\nb) opažanjem, proučavanjem, rastavljanjem ili testiranjem proizvoda ili predmeta koji je učinjen dostupnim javnosti ili koji je zakonito u posjedu osobe koja je pribavila informacije i koja nije vezana nikakvom pravno valjanom obvezom da ograniči pribavljanje poslovne tajne, \r\nc) ostvarivanjem prava radnika ili predstavnika radnika na informiranje, savjetovanje i sudjelovanje u skladu s posebnim propisima ili pravnom stečevinom Europske unije ili, \r\nd) svakom drugom radnjom koja je u tim okolnostima u skladu s dobrim poslovnim običajima. \r\nPribavljanje, korištenje ili otkrivanje poslovne tajne smatra se zakonitim u onoj mjeri u kojoj se takvo pribavljanje, korištenje ili otkrivanje zahtijeva ili dopušta posebnim propisima ili pravnom stečevinom Europske unije. ',
                value: '',
            },
        ],
        value: '',
    },
    {
        title: 'NEZAKONITO PRIBAVLJANJE, KORIŠTENJE I OTKRIVANJE POSLOVNIH TAJNI',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Pribavljanje poslovne tajne bez pristanka nositelja poslovne tajne smatra se nezakonitim kada je poslovna tajna pribavljena neovlaštenim pristupom, prisvajanjem ili umnožavanjem bilo kojih dokumenata, predmeta, materijala, tvari ili elektroničkih spisa koje zakonito kontrolira nositelj poslovne tajne i koji sadržavaju poslovnu tajnu ili se poslovna tajna iz njih može izvesti ili bilo kojim drugim postupanjem koje se u tim okolnostima smatra protivnim dobrim poslovnim običajima.\r\nKorištenje ili otkrivanje poslovne tajne smatra se nezakonitim kada ga bez pristanka nositelja poslovne tajne učini osoba za koju je pribavila poslovnu tajnu nezakonito ili kršeći sporazum o povjerljivosti ili bilo koju drugu obvezu neotkrivanja poslovne tajne ili kršeći ugovornu ili obvezu iz ovog Pravilnika kojom se ograničava korištenje poslovne tajne. \r\nPribavljanje, korištenje ili otkrivanje poslovne tajne smatra se nezakonitim i kada je osoba u trenutku pribavljanja, korištenja ili otkrivanja znala, ili je u tim okolnostima trebala znati, da je poslovna tajna pribavljena izravno ili neizravno od druge osobe koja je nezakonito koristila ili otkrila poslovnu tajnu. \r\nNezakonitim korištenjem poslovne tajne smatraju se i proizvodnja, nuđenje ili stavljanje na tržište robe kojom je počinjena povreda odnosno u te svrhe uvoz, izvoz ili skladištenje robe kojom je počinjena povreda, kao i nuđenje ili pružanje usluga pri kojima se koristi poslovna tajna, ako je osoba koja je provodila takve aktivnosti znala ili je u tim okolnostima trebala znati da je poslovna tajna korištena nezakonito.                 ',
                value: '',
            },
        ],
        value: '',
    },
    {
        title: 'POSLJEDICE NEPRIDRŽAVANJA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Poslodavac ima pravo zahtijevati mjere, postupke i pravna sredstva (uključujući i potraživati naknade štete) predviđena zakonom radi sprječavanja nezakonitog pribavljanja, korištenja ili otkrivanja svoje poslovne tajne odnosno ostvarivanja pravne zaštite u tom pogledu. \r\nOsim toga, nepridržavanje odredbi ovog Pravilnika predstavlja povredu iz radnog odnosa i može predstavljati osnovu za otkaz ugovora o radu.',
                value: '',
            },
        ],
        value: '',
    },
    {
        title: 'PRIMJENA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Ovaj Pravilnik se primjenjuje nakon proteka roka od 8 dana od dana objave odnosno stavljanja na na oglasnu ploču Poslodavca.',
                value: '',
            },
        ],
        value: '',
    },
            
   
    {
        mandatory: true,
        static: true,
        type: 2, // date and place
        statements: [
            {
                type: 'input',
                mandatory: true,
                parts: [
                    {
                        type: 'text',
                        content: 'U'
                    },
                    {
                        type: 'input',
                        value: '',
                        placeholder: "Upišite mjesto",
                        required: true
                    },
                    {
                        type: 'text',
                        content: ', dana'
                    },
                    {
                        type: 'date',
                        value: new Date(),
                        required: true
                    },
                    {
                        type: 'text',
                        content: 'godine.',
                    }
                ]
            },
        ]
    },
    {
        mandatory: true,
        static: true,
        type: 3,  // signatures
        statements: [],
    },
    {
        static: true,
        mandatory: false,
        type: 4,  
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Obavijest:\r\n1) Oglasna ploča Poslodavca \r\n2) Arhiva',
                
            }
        ]
    },
],
};




// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/220_pravilnik_o_poslovnoj tajni.ts